// src/components/Header.jsx
import "./Header.css";
import LanguageSelector from "./LanguageSelector";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLangTranslation } from "../utils/translation";

export default function Header() {
  const { lang = "en" } = useParams();
  const t = useLangTranslation("common");
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  // 라우트 변경 시 자동 닫기
  useEffect(() => setOpen(false), [pathname]);

  const close = () => setOpen(false);

  return (
    <header>
      <div className="header-inner">
        {/* 좌측 로고 */}
        <Link to={`/${lang}`} className="header-logo" aria-label="EDGE">
          <img src="/assets/logo-dark.svg" alt="EDGE logo" />
        </Link>

        <div className="header-actions">
        {/* 우측 네비게이션 (데스크톱) */}
        <nav className="header-nav-right nav-desktop" aria-label="Primary">
          <NavLink to={`/${lang}/about`}>{t("header.about")}</NavLink>
          <NavLink to={`/${lang}/games`}>{t("header.games")}</NavLink>
          <NavLink to={`/${lang}/careers`}>{t("header.careers")}</NavLink>
        </nav>

        <LanguageSelector drawerOpen={open} onOpen={close} />
        {/* 햄버거 버튼 (모바일에서만 노출) */}
        <button
          className={`nav-toggle ${open ? "open" : ""}`}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen(v => !v)}
        >
          <span className="bar" />
          <span className="bar" />
          <span className="bar" />
        </button>
        </div>
      </div>

      {/* 백드롭 */}
      <div className={`backdrop ${open ? "show" : ""}`} onClick={close} />

      {/* 우측 사이드바 */}
      <aside id="mobile-navigation" className={`side-drawer ${open ? "open" : ""}`} aria-hidden={!open} inert={!open ? true : undefined}>
        <div className="drawer-header">
          <img className="drawer-brand" src="/assets/logo-dark.svg" alt="EDGE" />
        </div>
        <div className="drawer-eyebrow">INDEPENDENT MINDS. SHARED PLAY.</div>
        <nav className="drawer-nav" aria-label="Mobile navigation">
          {['about', 'games', 'careers'].map((page, index) => (
            <NavLink key={page} to={`/${lang}/${page}`} onClick={close}>
              <span className="drawer-index" aria-hidden="true">0{index + 1}</span>
              <span>{t(`header.${page}`)}</span>
              <span className="drawer-arrow" aria-hidden="true">↗</span>
            </NavLink>
          ))}
        </nav>
        <div className="drawer-footer">
          <span className="drawer-footer-mark" aria-hidden="true">+</span>
          <p>Small team.<br />Wider play.</p>
          <span className="drawer-footer-caption">FROM KOREA. FOR THE WORLD.</span>
        </div>
      </aside>
    </header>
  );
}
